import type { ColorPair } from '~/models/Presentation/BasePage'
import { computed, ref } from 'vue'
import { colorMap } from '~/utils/colors'
import { ColorName } from '~/models/Content/Color'

const internalColorPair = ref<ColorPair | null>(null)

function createColorPair(text: ColorName, bg: ColorName, isDark: boolean): ColorPair {
  const [bgFallback, textFallback] = colorMap.values()
  return {
    textName: text,
    text: colorMap.get(text) ?? textFallback,
    backgroundName: bg,
    background: colorMap.get(bg) ?? bgFallback,
    isDark,
  }
}

const colorPairs: Record<string, ColorPair> = {
  'Gerd': createColorPair(ColorName.GreenPop, ColorName.Green50, true),
  'Gerd 2': createColorPair(ColorName.Green50, ColorName.GreenPop, false),
  'Gina': createColorPair(ColorName.Coral20, ColorName.Green50, true),
  'Gina 2': createColorPair(ColorName.Green50, ColorName.Coral20, false),
  'Gitte': createColorPair(ColorName.YellowPop, ColorName.Green30, true),
  'Gitte 2': createColorPair(ColorName.Green30, ColorName.YellowPop, false),
  'Gøril': createColorPair(ColorName.Seagreen10, ColorName.Seagreen50, true),
  'Gøril 2': createColorPair(ColorName.Seagreen50, ColorName.Seagreen10, false),
  'Ronald': createColorPair(ColorName.CoralPop, ColorName.Coral60, true),
  'Ronald 2': createColorPair(ColorName.Coral60, ColorName.CoralPop, false),
  'Ruben': createColorPair(ColorName.Coral20, ColorName.Blue50, true),
  'Ruben 2': createColorPair(ColorName.Blue50, ColorName.Coral20, false),
  'Rasmus': createColorPair(ColorName.Yellow30, ColorName.Gray50, true),
  'Rasmus 2': createColorPair(ColorName.Gray50, ColorName.Yellow30, false),
  'Violet 60 / Yellow pop': createColorPair(ColorName.Violet60, ColorName.YellowPop, false),
  'Yellow pop / Violet 60': createColorPair(ColorName.YellowPop, ColorName.Violet60, true),
  'Blue 60 / Orange pop': createColorPair(ColorName.Blue60, ColorName.OrangePop, false),
  'Orange pop / Blue 60': createColorPair(ColorName.OrangePop, ColorName.Blue60, true),
  'Green 60 / Seagreen pop': createColorPair(ColorName.Green60, ColorName.SeagreenPop, false),
  'Seagreen pop / Green 60': createColorPair(ColorName.SeagreenPop, ColorName.Green60, true),
  'Blue 60 / Blue pop': createColorPair(ColorName.Blue60, ColorName.BluePop, false),
  'Blue pop / Blue 60': createColorPair(ColorName.BluePop, ColorName.Blue60, true),
  'Violet 40 / Orange 10': createColorPair(ColorName.Violet40, ColorName.Orange10, false),
  'Orange 10 / Violet 40': createColorPair(ColorName.Orange10, ColorName.Violet40, true),
  'Gray 60 / Gray 5': createColorPair(ColorName.Gray60, ColorName.Gray5, false),
  'Gray 5 / Gray 60': createColorPair(ColorName.Gray5, ColorName.Gray60, true),
  'Purple 50 / Coral 5': createColorPair(ColorName.Purple50, ColorName.Coral5, false),
  'Coral 5 / Purple 50': createColorPair(ColorName.Coral5, ColorName.Purple50, true),
}

export default () => {
  const activeColorPair = computed(() => {
    return internalColorPair
  })

  const setActiveColorPair = (colorPair: ColorPair) => {
    internalColorPair.value = colorPair
  }

  const resetActiveColorPair = () => {
    internalColorPair.value = null
  }

  const getBackgroundColor = (colorName: string) => colorName || 'blue-10'

  const getColorPair = (colorPairName: string) => colorPairName ? colorPairs[colorPairName] : colorPairs.Gerd

  return {
    getColorPair,
    getBackgroundColor,
    activeColorPair,
    setActiveColorPair,
    resetActiveColorPair,
  }
}
